import { GRIDS } from "./allGrids";

/**
 * A set of delivery areas that share one order book.
 *
 * JEPX couples neighbouring areas when there is no binding interconnector
 * constraint between them, so their books carry identical bids and asks. Showing
 * them as separate columns is nine columns of duplicated numbers; showing them
 * as one column is what a trader actually reads.
 */
export type AreaCluster = {
  id: string;
  displayName: string;
  areaCodes: string[];
};

export const AREA_CLUSTERS: AreaCluster[] = [
  { id: "HOKK", displayName: "HOKK", areaCodes: ["1"] },
  { id: "TOHO_TOKY", displayName: "TOHO-TOKY", areaCodes: ["2", "3"] },
  {
    id: "CHUB_HOKU_KANS",
    displayName: "CHUB-HOKU-KANS",
    areaCodes: ["4", "5", "6"],
  },
  { id: "CHUG_SHIK", displayName: "CHUG-SHIK", areaCodes: ["7", "8"] },
  { id: "KYUS", displayName: "KYUS", areaCodes: ["9"] },
];

const CLUSTER_BY_AREA = new Map<string, AreaCluster>();
for (const cluster of AREA_CLUSTERS) {
  for (const areaCode of cluster.areaCodes) {
    CLUSTER_BY_AREA.set(areaCode, cluster);
  }
}

export const clusterOfArea = (areaCode: string): AreaCluster => {
  const cluster = CLUSTER_BY_AREA.get(areaCode);
  if (cluster) {
    return cluster;
  }
  return {
    id: `AREA_${areaCode}`,
    displayName: areaCode,
    areaCodes: [areaCode],
  };
};

export const clusterAreaNames = (cluster: AreaCluster): string =>
  cluster.areaCodes
    .map(
      (code) =>
        GRIDS.find((grid) => grid.areaCode === code)?.displayName ?? code
    )
    .join(" + ");
